/* BDEK accessibility helpers, loaded on every page (layout/theme.liquid).
   Announcement bar (rotating on phones): links in hidden messages leave the keyboard order,
   and the bar starts paused for people who ask their device to reduce motion. */
(function () {
  function syncSlides(bar) {
    bar.querySelectorAll('.announcement-slider__slide').forEach(function (slide) {
      var hidden = slide.getAttribute('aria-hidden') === 'true';
      slide.querySelectorAll('a, button, input, select, textarea').forEach(function (el) {
        if (hidden) {
          el.setAttribute('tabindex', '-1');
        } else if (el.getAttribute('tabindex') === '-1') {
          el.removeAttribute('tabindex');
        }
      });
    });
  }

  function init() {
    var bar = document.getElementById('AnnouncementSlider');
    if (!bar) return;
    syncSlides(bar);
    new MutationObserver(function () {
      syncSlides(bar);
    }).observe(bar, { subtree: true, attributes: true, attributeFilter: ['aria-hidden'] });

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var pauseBtn = bar.closest('.slideshow-wrapper') && bar.closest('.slideshow-wrapper').querySelector('.slideshow__pause');
    if (reduce && pauseBtn && bar.classList.contains('flickity-enabled') && !pauseBtn.classList.contains('is-paused')) {
      pauseBtn.click();
    }
  }

  if (document.readyState === 'complete') {
    init();
  } else {
    window.addEventListener('load', init);
  }
})();

/* Return focus after a drawer closes (WCAG 2.4.3, audit 2026-10-18).
   Impulse's drawers blur the focused element on close and only refocus the opener when it has
   aria-expanded, so "Add to cart" (cart drawer) and the phone filter drawer left keyboard users at
   the top of the page. Remember the last focused control outside any drawer/dialog and, shortly
   after a drawer closes (Escape or a close button), put focus back there if nothing else has it. */
(function () {
  var inLayer = '.drawer, [role="dialog"], [aria-modal="true"], [data-bdek-filter-drawer], .modal';
  var lastOutside = null;

  document.addEventListener('focusin', function (event) {
    var t = event.target;
    if (t && t !== document.body && t.closest && !t.closest(inLayer)) lastOutside = t;
  }, true);

  function restoreSoon() {
    var target = lastOutside;
    if (!target) return;
    window.setTimeout(function () {
      var a = document.activeElement;
      var lost = !a || a === document.body || a === document.documentElement;
      if (lost && target.isConnected && target.offsetParent !== null) target.focus({ preventScroll: true });
    }, 650); // after Impulse's 500ms close timer
  }

  document.addEventListener('keyup', function (event) {
    if (event.key === 'Escape') restoreSoon();
  }, true);

  document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('.js-drawer-close, .bdek-collection__close, [data-bdek-filter-close], [data-bdek-apply]')) restoreSoon();
  }, true);
})();

/* Review privacy (2026-10-19): a few reviewers typed their email address as their name (e.g. a
   review synced from the Shop app that Judge.me can't edit or hide). Wherever a review shows text
   that is only an email address, show just its first letter ("N.") instead. Covers Judge.me's
   widgets and carousels on every page, including reviews that load later. */
(function () {
  var EMAIL = /^\s*[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\s*$/;
  var SCOPE = '.jdgm-widget, [class*="jdgm-"], [class*="jm-"], [data-bdek-reviews]';

  function mask(root) {
    if (!root || !root.querySelectorAll) return;
    var areas = root.matches && root.matches(SCOPE) ? [root] : root.querySelectorAll(SCOPE);
    Array.prototype.forEach.call(areas, function (area) {
      var walker = document.createTreeWalker(area, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        if (EMAIL.test(node.nodeValue)) {
          node.nodeValue = node.nodeValue.trim().charAt(0).toUpperCase() + '.';
        }
      }
    });
  }

  function start() {
    mask(document.body);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType === 1) mask(n.closest ? n.closest(SCOPE) || n : n);
          else if (n.nodeType === 3 && n.parentElement) mask(n.parentElement.closest(SCOPE));
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
